import Button, { type ButtonProps } from '@components/designSystem/Button'
import Tooltip from '@components/designSystem/Tooltip'
import { cx } from '@utils/cx.ts'

interface Props extends Omit<ButtonProps, 'variant' | 'size'> {
    label: string
    isActive?: boolean
    shouldDisableTooltipOnActive?: boolean
}

function ToolbarButton({ children, className, label, isActive, shouldDisableTooltipOnActive = false, ...rest }: Props) {
  return (
    <Tooltip title={label} placement='left' isDisabled={isActive && shouldDisableTooltipOnActive}>
      <Button
        aria-label={label}
        variant={isActive ? 'dark' : 'outline'}
        size='lg'
        className={cx('size-11', className)}
        {...rest}
        iconLeading={children}
      >
      </Button>
    </Tooltip>
  )
}

export default ToolbarButton